import { ShieldOff, Mail, LogOut } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useAuthStore } from "@/stores/auth-store"

export function OrgDeactivatedScreen() {
  const { signOut } = useAuthStore()

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full px-6 text-center">
        <ShieldOff className="mx-auto mb-6 h-12 w-12 text-muted-foreground" />

        <h1 className="text-lg font-semibold mb-2">
          Access Paused
        </h1>

        <p className="text-sm text-muted-foreground mb-6">
          Your organisation's access to BidContext has been paused.
          Please contact support for assistance.
        </p>

        <div className="flex flex-col gap-3">
          <a href="mailto:hello@bidcontext.ai">
            <Button className="w-full">
              <Mail className="h-4 w-4 mr-2" />
              Contact Support
            </Button>
          </a>

          <Button
            variant="outline"
            onClick={() => void signOut()}
          >
            <LogOut className="h-4 w-4 mr-2" />
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  )
}
